import * as React from "react";
import { WithStyles, withStyles, createStyles, Theme } from 'components/controls/styles';

interface Props {
}

class PageHeader extends React.PureComponent<Props & WithStyles<typeof styles>> {

    render() {
        const { classes, children } = this.props;
        return <div className={classes.root}>{children}</div>;
    }
}


export const styles = (theme: Theme) => createStyles({
    root: {
        padding: theme.spacing.unit * 2,
        backgroundColor: theme.palette.info.main,
        borderBottom: `1px solid ${theme.palette.primary.light}`
    },
});

export default withStyles(styles)(PageHeader);